<template>
  <v-layout row justify-center>
    <confirmation-dialog
      v-if="showDeleteConfirmation"
      :show="showDeleteConfirmation"
      :title="$t('confirmation.deleteTitle')"
      :message="$t('confirmation.' + messageKey, [itemToDelete[itemKey]])"
      @cancel="deleteRejected"
      @confirm="deleteConfirmation"
    ></confirmation-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      itemToDelete: {},
      showDeleteConfirmation: false
    };
  },
  props: {
    messageKey: String,
    itemKey: {
      type: String,
      default: "name"
    }
  },
  methods: {
    deleteAction(item) {
      this.itemToDelete = item;
      this.showDeleteConfirmation = true;
    },
    deleteRejected() {
      this.itemToDelete = {};
      this.showDeleteConfirmation = false;
    },
    deleteConfirmation() {
      this.$emit("confirm", this.itemToDelete);
      this.deleteRejected();
    }
  }
};
</script>
